import { render, staticRenderFns } from "./LiveEditExternal.vue?vue&type=template&id=0c13a8bb&scoped=true&"
import script from "./LiveEditExternal.vue?vue&type=script&lang=js&"
export * from "./LiveEditExternal.vue?vue&type=script&lang=js&"
import style0 from "./LiveEditExternal.vue?vue&type=style&index=0&id=0c13a8bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c13a8bb",
  null
  
)

export default component.exports